import { Route, Location } from 'vue-router';
import { JWTLoginSessionManager } from '@/authentication/services/session/session-manager';
import { parseTokenParamFromRoute } from '@/authentication/services/parse-token-param-from-route';
import { JWT } from '@/authentication/services/interfaces';
import { DEFAULT_PAGE_LOCATION, LOGIN_PAGE_LOCATION } from '@/authentication/services/locations';
import { ServiceTokens } from '@/di/tokens';
import type { Store } from 'vuex';

export class InstantLoginRedirectionService {
    public static inject = [ServiceTokens.BaseStore] as const;
    // @ts-ignore
    constructor(private store: Store<unknown>) {}

    redirect(currentRoute: Route): Location {
        const sessionManager = new JWTLoginSessionManager();
        // const openInAppStoreService = OpenInAppStoreServiceFactory(this.store);

        try {
            const token = parseTokenParamFromRoute(currentRoute);
            sessionManager.start(token as JWT);

            // Uncomment to enable SSO on a mobile device
            // if (isWeb() && getIsMobile()) {
            //     openInAppStoreService.showNotification();
            // }

            return { ...DEFAULT_PAGE_LOCATION, query: {} };
        } catch (error) {
            console.error(error);
            return { ...LOGIN_PAGE_LOCATION, query: {} };
        }
    }
}
